export const Field = ({ label, htmlFor, required, children }) => (
  <div>
    <label htmlFor={htmlFor} className="field-label">
      {label}
      {required && <span className="ml-1 text-gold">*</span>}
    </label>
    {children}
  </div>
);

export const inputProps = (testid) => ({
  "data-testid": testid,
  className: "field-input",
});
